export const SALUTATION = [
    'Mr',
    'Ms',
    'Mrs',
    'Miss',
    'Kumar',
    'Shri',
    'Smt',
    'Dr',
    'Master',
    'Baby',
    'Mohd',
    'B/O',
];

export const MALE_SALUTATION = new Set(['Mr', 'Kumar', 'Shri', 'Dr', 'Master', 'Mohd']);

export const MARITAL_STATUS = ['Single', 'Married', 'Divorced', 'Widowed', 'Separated', 'Unknown'];

export const INVALID_PHONE_NUMBER = 'Invalid phone number';

export type YEARS = 'YEARS';
export type MONTHS = 'MONTHS';
export type DAYS = 'DAYS';
